import { render } from "./VueAppsMountContainer.vue?vue&type=template&id=3c5e6c0a"
import script from "./VueAppsMountContainer.vue?vue&type=script&lang=js"
export * from "./VueAppsMountContainer.vue?vue&type=script&lang=js"

import "./VueAppsMountContainer.vue?vue&type=style&index=0&id=3c5e6c0a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__